import * as types from "./types";

const sendRequest = () => ({
   type: types.SEND_START,
});

const sendCompleted = (data, modalData) => ({
   type: types.SEND_COMPLETED,
   payload: { data, modalData },
});

const sendFailed = (error, data) => ({
   type: types.SEND_FAILED,
   payload: { error, data },
});

const setSendModalState = (data) => ({
   type: types.SET_SEND_MODAL_STATE,
   payload: data,
});
const setUpdateMethods = (data) => ({
   type: types.SET_UPDATE_METHODS,
   payload: data,
});


export {
   sendRequest,
   sendCompleted,
   sendFailed,
   setSendModalState,
   setUpdateMethods,
};
